module.exports = __webpack_public_path__ + "7a317fe31b2820883f8411a69f6ff2f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/G180.jpg
// module id = 687
// module chunks = 0